module.exports = __webpack_public_path__ + "img/tagManagement.72a43952.svg";